import {cardTitle, container, title} from "../../nextjs-material-kit.js";
import {regularCta} from "../button";

// Also currently used for employer details.
const landingPageStyle = (theme) => ({
  detailSection: {
    ...container(theme),
  },
  container: {
    zIndex: "12",
    height: "auto",
    ...container(theme),
  },
  paddingZero: {
    padding: "0 !important",
  },
  marginZero: {
    margin: "0 !important",
  },
  title: {
    ...title,
    float: "left",
    margin: "0",
    color: "#095a70",
    textDecoration: "none",
    fontFamily: "var(--font-brandon-grotesque)",
    fontWeight: 900,
    fontSize: "3.5rem",
  },
  subtitle: {
    fontSize: "1.313rem",
    maxWidth: "500px",
    margin: "10px auto 0",
  },
  cardTitle: {
    ...cardTitle,
    fontFamily: "var(--font-brandon-grotesque)",
    fontWeight: 900,
    textAlign: "left",
    color: "#095A70",
    fontSize: "3.5rem",
    paddingLeft: "0",
    lineHeight: 1,
  },
  main: {
    position: "relative",
    zIndex: "3",
  },
  darkBlue: {
    backgroundColor: "#095a70",
  },
  white_bg: {
    background: "#ffffff",
  },
  ctaContainer: {
    display: "flex",
    // Make sizing closer to the top section. If we want *all* CTAs to have this much breathing
    // space we should think about bumping the padding inside, instead of relying on flex
    // containers' behaviour.
    minHeight: "42px",
    paddingLeft: "0",
    margin: "20px 0",
    "@media (max-width: map-get($grid-breakpoints, 'lg'))": {
      justifyContent: "space-around",
    },
  },
  cta: regularCta,
  jobSidebar: {
    paddingTop: '0.75rem',
  }
});

export default landingPageStyle;
